import { render, staticRenderFns } from "./Confirmed.vue?vue&type=template&id=28132a48&scoped=true&"
import script from "./Confirmed.vue?vue&type=script&lang=js&"
export * from "./Confirmed.vue?vue&type=script&lang=js&"
import style0 from "./Confirmed.vue?vue&type=style&index=0&rel=stylesheet%2Fless&lang=less&"
import style1 from "./Confirmed.vue?vue&type=style&index=1&id=28132a48&rel=stylesheet%2Fless&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28132a48",
  null
  
)

export default component.exports